import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const HealthInsuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section health-insurance-fin">
                <h2 className="other-pages-title">Health Insurance</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/health-insurance-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Health Insurance</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Health Insurance?</h2>

                <p className="info-loan-description-smco">
                    Health insurance is a type of insurance coverage that pays for medical and surgical expenses incurred by the insured. It provides financial protection against high healthcare costs, ensuring that individuals and families can access quality medical care without facing financial hardship. Health insurance plans cover hospitalization, doctor visits, prescription drugs, and preventive care.
                    <br /><br />
                    There are various types of health insurance policies, including individual plans, family floater plans, and group insurance offered by employers. Plans can be indemnity-based (reimbursement) or managed care plans. Premiums are influenced by age, health status, coverage amount, and location. Riders can be added for additional benefits like critical illness coverage or maternity benefits.
                    <br /><br />
                    Health insurance is crucial in today's world where medical costs are rising rapidly. It not only covers treatment expenses but also offers cashless hospitalization, pre and post-hospitalization coverage, and tax benefits under Section 80D. Choosing the right plan involves assessing your healthcare needs, budget, and the network of hospitals covered by the insurer.
                    <br /><br />
                    Regular health check-ups and maintaining a healthy lifestyle can help in getting better premium rates. Health insurance promotes proactive healthcare and provides peace of mind by safeguarding against unexpected medical expenses.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Hospitalization coverage:</strong> Covers room rent, ICU charges, and surgery costs.</li>
                        <li><strong>Cashless treatment:</strong> Direct billing to insurer at network hospitals.</li>
                        <li><strong>Pre and post-hospitalization:</strong> Coverage for expenses before and after admission.</li>
                        <li><strong>Day care procedures:</strong> Covers same-day surgeries and treatments.</li>
                        <li><strong>Tax benefits:</strong> Premiums are deductible under Section 80D.</li>
                        <li><strong>Preventive care:</strong> Annual health check-ups and wellness programs.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Health Insurance</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Individual Health Insurance:</strong> Coverage for a single person.</li>
                        <li><strong>Family Floater Plan:</strong> Covers the entire family under one sum insured.</li>
                        <li><strong>Senior Citizen Plans:</strong> Specialized coverage for elderly individuals.</li>
                        <li><strong>Critical Illness Insurance:</strong> Lumpsum payout for major illnesses.</li>
                        <li><strong>Top-up Plans:</strong> Additional coverage over existing health insurance.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Financial protection:</strong> Safeguards against high medical bills.</li>
                        <li><strong>Access to quality care:</strong> Network of hospitals and specialists.</li>
                        <li><strong>Peace of mind:</strong> Worry-free medical treatment for you and your family.</li>
                        <li><strong>Tax savings:</strong> Reduce taxable income with premium deductions.</li>
                        <li><strong>Preventive healthcare:</strong> Encourages regular check-ups and healthy living.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default HealthInsuranceInfo;
